import "./less/iPortfolio.scss";

import ReactDOM from "react-dom/client";
import App from "./App";
import DialogProvider from "./libs/dialog/DialogProvider";
import PathProvider from "./libs/path/PathProvider";
import SnackbarProvider from "./libs/dialog/SnackbarProvider";
import { PortfolioProvider } from "./hooks/PortfolioProvider";
import { LocalizationProvider } from "@mui/x-date-pickers";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

(function main(){
  const root = ReactDOM.createRoot(document.getElementById("root")!);
  root.render(<PortfolioProvider><SnackbarProvider><PathProvider>
    <LocalizationProvider dateAdapter={AdapterDayjs}><DialogProvider>
      <App/>
    </DialogProvider></LocalizationProvider>
    </PathProvider></SnackbarProvider></PortfolioProvider>);

  serviceWorkerRegistration.register()
})()
